import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import axios from 'axios';
import BarreNav from '../components/BarreNav';

const api = axios.create({ baseURL: '/api' });

function getToken() { return localStorage.getItem('token'); }

function NumStepper({ label, value, onChange, disabled, hint }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--texte)', marginBottom: 6 }}>{label}</div>
      {hint && <div style={{ fontSize: 11, color: 'var(--texte-doux)', marginBottom: 6 }}>{hint}</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button
          onClick={() => !disabled && onChange(Math.max(0, value - 1))}
          disabled={disabled || value === 0}
          style={{ width: 38, height: 38, borderRadius: 10, border: '1.5px solid var(--bord-fort)', background: disabled ? 'var(--fond)' : '#fff', fontSize: 20, fontWeight: 700, color: disabled ? 'var(--texte-faible)' : 'var(--danger)', cursor: disabled ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >−</button>
        <div style={{ minWidth: 36, textAlign: 'center', fontSize: 20, fontWeight: 700, color: disabled ? 'var(--texte-faible)' : 'var(--texte)' }}>{value}</div>
        <button
          onClick={() => !disabled && onChange(value + 1)}
          disabled={disabled}
          style={{ width: 38, height: 38, borderRadius: 10, border: '1.5px solid var(--bord-fort)', background: disabled ? 'var(--fond)' : '#fff', fontSize: 20, fontWeight: 700, color: disabled ? 'var(--texte-faible)' : 'var(--accent)', cursor: disabled ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >+</button>
        {disabled && <span style={{ fontSize: 11, color: 'var(--texte-faible)', fontStyle: 'italic' }}>Bientôt disponible</span>}
      </div>
    </div>
  );
}

function Field({ label, value, onChange, placeholder, type = 'text' }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--texte)', marginBottom: 6 }}>{label}</div>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{ width: '100%', padding: '11px 13px', border: '0.5px solid var(--bord-fort)', borderRadius: 10, fontSize: 14, background: 'var(--surface-2)', color: 'var(--texte)', outline: 'none', boxSizing: 'border-box' }}
      />
    </div>
  );
}

export default function CommandeONT() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [commande, setCommande] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [message, setMessage] = useState('');

  // Articles
  const [cartonsOnt, setCartonsOnt] = useState(0);
  const [sachetsOrange, setSachetsOrange] = useState(0);
  const [sachetsBlanc, setSachetsBlanc] = useState(0);
  const [sachetsViolet, setSachetsViolet] = useState(0);
  const [sachetsGris, setSachetsGris] = useState(0);
  const [nbPTO, setNbPTO] = useState(0);

  // Livraison
  const [ville, setVille] = useState('');
  const [codePostal, setCodePostal] = useState('');
  const [telephone, setTelephone] = useState('');
  const [mail, setMail] = useState('');
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');

  useEffect(() => {
    api.get('/ont-orders/my', { headers: { Authorization: `Bearer ${getToken()}` } })
      .then(r => {
        const enCours = r.data.orders.find(o => o.statut === 'en_cours');
        setCommande(enCours || r.data.orders[0] || null);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async () => {
    if (!ville.trim() || !codePostal.trim() || !telephone.trim() || !nom.trim() || !prenom.trim()) {
      setMessage('Veuillez remplir tous les champs de livraison.');
      return;
    }
    const total = cartonsOnt + sachetsOrange + sachetsBlanc + sachetsViolet + sachetsGris + nbPTO;
    if (total === 0) {
      setMessage('Veuillez commander au moins un article.');
      return;
    }
    setSending(true);
    setMessage('');
    try {
      const r = await api.post('/ont-orders', {
        articles: { cartons_ont: cartonsOnt, sachets_orange: sachetsOrange, sachets_blanc: sachetsBlanc, sachets_violet: sachetsViolet, sachets_gris: sachetsGris, nb_pto: nbPTO },
        livraison: { ville, code_postal: codePostal, telephone, mail, nom, prenom },
      }, { headers: { Authorization: `Bearer ${getToken()}` } });
      setCommande(r.data.order);
    } catch {
      setMessage('Erreur lors de l\'envoi de la commande. Réessayez.');
    } finally {
      setSending(false);
    }
  };

  const handleConfirm = async () => {
    if (!commande) return;
    setConfirming(true);
    try {
      const r = await api.put(`/ont-orders/${commande.id}/confirm`, {}, { headers: { Authorization: `Bearer ${getToken()}` } });
      setCommande(r.data.order);
    } catch {
      setMessage('Erreur lors de la confirmation. Réessayez.');
    } finally {
      setConfirming(false);
    }
  };

  const formatDate = iso => new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

  return (
    <div className="app-shell">
      <div className="topbar">
        <div style={{ width: 32 }} />
        <div className="topbar-title">Commande ONT</div>
        <div style={{ width: 32 }} />
      </div>

      <div className="content">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--texte-doux)' }}>Chargement…</div>
        ) : commande ? (
          /* ─── Commande existante ─── */
          <div>
            <div style={{ background: commande.statut === 'confirme' ? 'var(--succes-fond)' : 'var(--attention-fond)', border: `1.5px solid ${commande.statut === 'confirme' ? 'var(--succes-bord)' : 'var(--attention-bord)'}`, borderRadius: 14, padding: '16px 16px', marginBottom: 20 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: commande.statut === 'confirme' ? 'var(--succes-texte)' : 'var(--attention-texte)', marginBottom: 4 }}>
                {commande.statut === 'confirme' ? '✅ Commande réceptionnée' : '⏳ Commande en cours de traitement'}
              </div>
              <div style={{ fontSize: 12, color: 'var(--texte-doux)' }}>Passée le {formatDate(commande.date_commande)}</div>
              {commande.date_confirmation && (
                <div style={{ fontSize: 12, color: 'var(--texte-doux)' }}>Confirmée le {formatDate(commande.date_confirmation)}</div>
              )}
            </div>

            <div className="section-card">
              <div className="section-label">Articles commandés</div>
              {[
                ['Cartons ONT', commande.articles.cartons_ont],
                ['Sachets Jarretière Orange', commande.articles.sachets_orange],
                ['Sachets Jarretière Blanche', commande.articles.sachets_blanc],
                ['Sachets Jarretière Violet', commande.articles.sachets_violet],
                ['Sachets Jarretière Gris', commande.articles.sachets_gris],
                ['Nombre de PTO', commande.articles.nb_pto],
              ].filter(([, v]) => v > 0).map(([label, val]) => (
                <div key={label} className="info-row">
                  <span className="info-key">{label}</span>
                  <span className="info-val" style={{ fontWeight: 700 }}>{val}</span>
                </div>
              ))}
            </div>

            <div className="section-card">
              <div className="section-label">Livraison Mondial Relay</div>
              {[
                ['Nom', `${commande.livraison.prenom} ${commande.livraison.nom}`],
                ['Ville', `${commande.livraison.ville} (${commande.livraison.code_postal})`],
                ['Téléphone', commande.livraison.telephone],
                ['E-mail', commande.livraison.mail],
              ].map(([label, val]) => (
                <div key={label} className="info-row">
                  <span className="info-key">{label}</span>
                  <span className="info-val">{val}</span>
                </div>
              ))}
            </div>

            {commande.statut === 'en_cours' && (
              <>
                <button
                  onClick={handleConfirm}
                  disabled={confirming}
                  style={{ width: '100%', padding: 14, background: 'var(--succes-texte)', color: '#fff', border: 'none', borderRadius: 14, fontSize: 15, fontWeight: 700, cursor: confirming ? 'not-allowed' : 'pointer', marginTop: 8 }}
                >
                  {confirming ? 'Confirmation…' : '✅ Confirmer la réception'}
                </button>
                <div style={{ fontSize: 12, color: 'var(--texte-doux)', textAlign: 'center', marginTop: 8 }}>Appuyez une fois le colis reçu</div>
              </>
            )}

            {message && <div style={{ marginTop: 12, padding: '10px 12px', borderRadius: 10, background: 'var(--danger-fond)', color: 'var(--danger-texte)', fontSize: 13 }}>{message}</div>}

            <button
              onClick={() => setCommande(null)}
              style={{ width: '100%', padding: 14, background: 'var(--surface)', color: 'var(--accent)', border: '1.5px solid var(--accent)', borderRadius: 14, fontSize: 14, fontWeight: 600, cursor: 'pointer', marginTop: 16 }}
            >
              + Passer une nouvelle commande
            </button>
          </div>
        ) : (
          /* ─── Formulaire commande ─── */
          <div>
            <div className="section-card">
              <div className="section-label">Articles</div>
              <NumStepper label="Cartons ONT" value={cartonsOnt} onChange={setCartonsOnt} />
              <NumStepper label="Sachets Jarretière Orange" value={sachetsOrange} onChange={setSachetsOrange} />
              <NumStepper label="Sachets Jarretière Blanche" value={sachetsBlanc} onChange={setSachetsBlanc} />
              <NumStepper label="Sachets Jarretière Violet" value={sachetsViolet} onChange={setSachetsViolet} />
              <NumStepper label="Sachets Jarretière Gris" value={sachetsGris} onChange={setSachetsGris} />
              <NumStepper label="Nombre de PTO" value={nbPTO} onChange={setNbPTO} />
              <NumStepper label="Touret 500m" value={0} onChange={() => {}} disabled hint="Bientôt disponible" />
            </div>

            <div className="section-card">
              <div className="section-label">Livraison Mondial Relay</div>
              <Field label="Prénom" value={prenom} onChange={setPrenom} placeholder="Ex : Jean" />
              <Field label="Nom" value={nom} onChange={setNom} placeholder="Ex : DUPONT" />
              <Field label="Ville de réception" value={ville} onChange={setVille} placeholder="Ex : Marseille" />
              <Field label="Code postal" value={codePostal} onChange={setCodePostal} placeholder="Ex : 13001" type="tel" />
              <Field label="Numéro de téléphone" value={telephone} onChange={setTelephone} placeholder="Ex : 0612345678" type="tel" />
              <Field label="Adresse e-mail" value={mail} onChange={setMail} placeholder="Ex : jean.dupont@email.com" type="email" />
            </div>

            {message && <div style={{ padding: '10px 12px', borderRadius: 10, background: 'var(--danger-fond)', color: 'var(--danger-texte)', fontSize: 13, marginBottom: 12 }}>{message}</div>}

            <button
              onClick={handleSubmit}
              disabled={sending}
              style={{ width: '100%', padding: 16, background: sending ? 'var(--texte-doux)' : 'var(--danger-plein)', color: '#fff', border: 'none', borderRadius: 14, fontSize: 16, fontWeight: 700, cursor: sending ? 'not-allowed' : 'pointer', marginBottom: 8 }}
            >
              {sending ? 'Envoi en cours…' : 'Passer la commande'}
            </button>
          </div>
        )}
        <div style={{ height: 16 }} />
      </div>

      <BarreNav actif="commande" />
    </div>
  );
}
